import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { faShieldAlt, faUserShield, faClipboardList } from '@fortawesome/free-solid-svg-icons';

import AuthLayout from '../components/AuthLayout';
import { stripSensitiveParams } from '../utils/urlToken';
import { adminApi, errorMessage } from './adminApi';
import '../pages/providerLogin/styles.css';

const MIN_LENGTH = 12;

const BENEFITS = [
  { icon: faUserShield, text: 'O link vale por 30 minutos e funciona uma vez só.' },
  { icon: faShieldAlt, text: 'Depois de criar a senha, o login continua pedindo o código por e-mail.' },
  { icon: faClipboardList, text: 'A troca fica registrada na auditoria do painel.' },
];

// Link do e-mail de "esqueci a senha" do painel.
export default function AdminResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    const linkToken = new URLSearchParams(location.search).get('token');
    if (!linkToken) {
      history.replace('/admin/login');
      return;
    }
    setToken(linkToken);
    // O token sai da barra de endereco e do historico.
    stripSensitiveParams();
  }, [location.search, history]);

  const valid = password.length >= MIN_LENGTH && password === confirm;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    setError('');
    try {
      await adminApi.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(errorMessage(err, 'Link inválido ou expirado. Peça um novo.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout eyebrow='Painel administrativo' title='Suporte do' highlight='Sobre Rodas.' benefits={BENEFITS}>
      {done ? (
        <div className='auth-form'>
          <div className='pl-sent' role='status'>
            <h2>Senha criada</h2>
            <p>Entre com a senha nova. Vamos pedir o código enviado ao seu e-mail.</p>
          </div>
          <button type='button' className='auth-submit' onClick={() => history.replace('/admin/login')}>Ir para o login</button>
        </div>
      ) : (
        <form className='auth-form' onSubmit={handleSubmit} noValidate>
          <header className='auth-form-header'>
            <h2>Criar senha nova</h2>
            <p>Use ao menos {MIN_LENGTH} caracteres.</p>
          </header>
          <div className='auth-field'>
            <label htmlFor='ad-new'>Senha nova</label>
            <input id='ad-new' type='password' autoComplete='new-password' value={password} maxLength={72} onChange={(e) => { setPassword(e.target.value); setError(''); }} />
          </div>
          <div className='auth-field'>
            <label htmlFor='ad-confirm'>Repita a senha</label>
            <input id='ad-confirm' type='password' autoComplete='new-password' value={confirm} maxLength={72} onChange={(e) => { setConfirm(e.target.value); setError(''); }} />
            {confirm && confirm !== password && <p className='pl-hint is-error'>As senhas não são iguais.</p>}
          </div>
          {error && <p className='pl-error' role='alert'>{error}</p>}
          <button type='submit' className='auth-submit' disabled={!valid || busy} aria-busy={busy}>
            {busy ? <><span className='auth-spinner' aria-hidden='true' />Salvando…</> : 'Salvar senha'}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
